
import { isMdaeWidgetOptionChangeEvent, updateStateAfterWidgetOptionChange } from '../../../common_components/mdae-framework';
import { actionTypes as asyncTypes, isAsyncOperation, isAsyncComplete, isAsyncFailure } from 'async-ops';
import { GET_CASE_SEARCH_PAGE_REFERENCE_DATA } from '../services/get-case-search-page-reference-data';
export const SET_CASE_SEARCH_FORM_DATA = 'SET_CASE_SEARCH_FORM_DATA';
export const SET_CASE_SEARCH_HEADER_DATA = 'SET_CASE_SEARCH_HEADER_DATA';
const initialError = {
    code: '',
    message: '',
    value: []
};

const initialState = {
    loading: false,
    error: initialError,
    serviceFrom: null,
    serviceTo: null,
    claimTypeCd: null,
    emdrPayerClaimId: null,
    caseSearchFormData: {
        patientFirstName: "",
        patientLastName: "",
        patientAcctNoOrig: "",
        medicalRecordNumber: "",
        payerRemitNo: "",
        patientDateofBirth: null,
        subscriberId: "",

    }
};
export default (state = initialState, action) => {
    let newState;
    switch (action.type) {
        case asyncTypes.OPERATION:
        case asyncTypes.COMPLETE:
        case asyncTypes.FAILURE:
            if (isAsyncComplete(GET_CASE_SEARCH_PAGE_REFERENCE_DATA)(action)) {
                return {
                    ...state,
                    serviceFrom: state.serviceFrom ?? action.response.referenceData.serviceFrom,
                    serviceTo: state.serviceTo ?? action.response.referenceData.serviceTo,
                    recordSubmissionMethodEnumDisplayList: action.response.recordSubmissionEnumDisplayList,
                };
            }
            return state;
        case SET_CASE_SEARCH_FORM_DATA:
            newState = { ...state };
            if (isMdaeWidgetOptionChangeEvent(action.data)) {
                newState = updateStateAfterWidgetOptionChange(newState, action.data);
            } else {
                newState = { ...newState, caseSearchFormData: { ...state.caseSearchFormData, ...action.data } };
            }
            return newState;
        case SET_CASE_SEARCH_HEADER_DATA:
            newState = { ...state };
            if (isMdaeWidgetOptionChangeEvent(action.data)) {
                newState = updateStateAfterWidgetOptionChange(newState, action.data);
            } else {
                newState = { ...newState, ...action.data };
            }
            return newState;

        default:
            return state;
    }
};

